<template>
  <div class="form-field placeholder-wrapper" :class="{'has-content': Boolean(internalValue)}">
    <label
      @click="handleLabelClick"
      :for="name"
      :class="{'has-content': Boolean(internalValue) }"
    >
      {{label}}

      <validation-message
      class="_ts1"
      :required="required"
      :invalid="invalid"
      :errorMessage="errorMessage" />
    </label>
    <ssn-input
      v-if="name=='ssn'"
      modifier="form-input"
      ref="input"
      :name="name"
      :id="name"
      v-model="internalValue"
      @click="$emit('click', $event)"/>
    <input v-else class="form-input" ref="input" :type="type" :name="name" :id="name" @click="$emit('click', $event)" v-model="internalValue" />
    <slot></slot>
  </div>
</template>

<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import SsnInput from '@atoms/SsnInput.vue'
  import ValidationMessage from '@atoms/ValidationMessage'

  export default {
    components: {
      SsnInput,
      ValidationMessage
    },
    mixins: [ ValueInputBindings ],
    props: {
      label: String,
      name: String,
      value: String,
      type: {
        value: String,
        default: 'text'
      },
      required: {
        type: Boolean,
        default: false
      },
      invalid: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
    methods: {
      handleLabelClick() {
        this.$refs.input.focus()
        this.$emit('click')
      }
    }
  }
</script>
<style scoped>
label {
  z-index: 1;
}
</style>
